import React from 'react';
import { useDashboardContext } from '../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import Modal from '../../../../components/Modal';
import CustomDropdown from '../../../../components/FilterDropDown';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import { useEffect } from 'react';

const GroupDetailsUpdations = ({ assignments }) => {
  const [selectedStudentId, setSelectedStudentId] = React.useState('');
  const [addMember, setAddMember] = React.useState(new Date().getSeconds());
  const [showError, setShowError] = React.useState(false);
  const {
    manageDisList,
    setManageDisList,
    setManageDist,
    manageDis,
    selectedGroupName,
    allStudents,
    addGroupMembers,
    allMessageGroupMembers,
    removeGroupMembers,
    slectedGroupId,
    searchValue,
    getAllAssignmentShareUsers,
    allAssignmentShareUsers,
    setAllAssignmentShareUsers,
    studentId,
    setStudentId,
    isLoading
  } = useDashboardContext();
  const manageDistListHandler = () => {
    setSelectedStudentId('');
    setManageDisList(!manageDisList);
    setManageDist(!manageDis);
  };

  const handleSelectChange = (event) => {
    setSelectedStudentId(event.target.value);
  };

  const addGroupMembersHandler = () => {
    if (selectedStudentId.length > 0 || studentId.length > 0) {
      assignments
        ? addGroupMembers(slectedGroupId, studentId)
        : addGroupMembers(slectedGroupId, selectedStudentId);
    }
    else {
      setShowError(true);
    }
    setSelectedStudentId('');
    setStudentId('');
    setAllAssignmentShareUsers([]);
    setAddMember(new Date().getSeconds());
  };

  const groupMemberDeleteHandler = (id) => {
    removeGroupMembers(slectedGroupId, id);
  };
  useEffect(() => {
    if (!manageDisList)
      setShowError(false);
  }, [manageDisList])
  return (
    <Modal
      isOpen={manageDisList}
      onClose={manageDistListHandler}
      titleName={`Members of ${selectedGroupName}`}
      contentWidth="100%">
      <div className="rename-group mb-4">
        <label className="form-label mb-3">
          Enter either a login id or user&#39;s name (Last, First), then select from dropdown and
          press add.
        </label>
        <div className="d-flex">
          {assignments && (
            <CustomDropdown
              options={allAssignmentShareUsers}
              onSelect={getAllAssignmentShareUsers}
              setOptions={setAllAssignmentShareUsers}
              onSubmit={addMember}
            />
          )}
          {!assignments && (
            <select value={selectedStudentId} onChange={handleSelectChange} className="form-select">
              <option value="" selected>
                -- Select a member --
              </option>
              {allStudents
                .filter(
                  (student) =>
                    student.fName.toLowerCase().includes(searchValue.toLowerCase()) ||
                    student.lName.toLowerCase().includes(searchValue.toLowerCase())
                )
                .map((item, index) => {
                  return (
                    <option key={index} value={item.login}>
                      {item.fName + ' ' + item.lName}
                    </option>
                  );
                })}
            </select>
          )}
          <button onClick={addGroupMembersHandler} className="btn btn-castleRed ms-3">
            Add
          </button>
        </div>
        {showError && (
          <div style={{ color: 'red' }}>
            Please enter a member name to add.
          </div>
        )}
      </div>

      <div className="custom-table table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Login ID</th>
              <th>Last Name</th>
              <th>First Name</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {!isLoading ? (
              allMessageGroupMembers?.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item.login}</td>
                    <td>{item.lName}</td>
                    <td>{item.fName}</td>
                    <td>
                      <div className="action-btns d-flex justify-content-end">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-top" className="custom-tooltip">
                              Delete
                            </Tooltip>
                          }>
                          <button
                            onClick={() => groupMemberDeleteHandler(item.login)}
                            className="error">
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </OverlayTrigger>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <>
                {[...Array(5)].map((_, index) => (
                  <tr key={index}>
                    <td>
                      <Skeleton />
                    </td>
                    <td>
                      <Skeleton />
                    </td>
                    <td>
                      <Skeleton />
                    </td>
                    <td>
                      <Skeleton />
                    </td>
                  </tr>
                ))}
              </>
            )}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-end mt-3">
        <button onClick={manageDistListHandler} className="btn btn-castleRed">
          Cancel
        </button>
      </div>
    </Modal>
  );
};

GroupDetailsUpdations.propTypes = {
  assignments: PropTypes.bool
};

export default GroupDetailsUpdations;
